import useFeatureFlagStoreContext from "../useFeatureFlagStoreContext";
var useFeatureFlagStore = function useFeatureFlagStore() {
  var _useFeatureFlagStoreC = useFeatureFlagStoreContext(function (store) {
      return store;
    }),
    fetchAllFlags = _useFeatureFlagStoreC.fetchAllFlags,
    fetchFlag = _useFeatureFlagStoreC.fetchFlag;
  return {
    fetchFlag: fetchFlag,
    fetchAllFlags: fetchAllFlags
  };
};
export default useFeatureFlagStore;